import Http from '../http'

export default {

  index() {
    return Http.get(`/users`)
  },
  searchUser(filter) {
    let {company_id, non_associated_members, query} = filter
    return Http.get(`/users`, {params: {
      company_id, non_associated_members, query
    }})
  },
  nonAssociatedMembersIndex(filter) {
    return Http.get(`/users`, {params: {...filter}})
  },
  indexByCompany(filter) {
    return Http.get(`/users`, {params: {...filter}})
  },


  create(user){
    return Http.post(`/users`, {user: {
      ...user,
      password: '#$&THRT2200',
      password_confirmation: '#$&THRT2200',
    }})
  },

  update(user){
    return Http.put(`/users/${user.id}`, {
      user: {
        ...user,
      },
    });
  },
  updateAvatar(id, user){
    return Http.put(`/users/${id}`, user);
  },

  show(id) {
    return Http.get(`/users/${id}`);
  },

  delete(id){
    return Http.delete(`/users/${id}`)
  }

}
